import { CREATE_ORG_GROUP_API_SUCCESS, OrganizationGroupActionTypes } from './organization-group.actions';
import { OrganizationGroupState } from './organization-group.types';

const initialState: OrganizationGroupState = {};

export default (state: OrganizationGroupState = initialState, action: OrganizationGroupActionTypes): OrganizationGroupState => {
  switch (action.type) {
    case CREATE_ORG_GROUP_API_SUCCESS:
      return {
        ...state,
        createdOrganizationGroup: action.payload,
        createRequestId: action.meta.requestId,
      };
    default:
      return state;
  }
};
